module.exports = __webpack_public_path__ + "img/note-1.81a5a4d6.svg";